import type { TroubleCard, TroubleTab } from '@/types/domains/TroubleType';

/**
 * トップ「お悩みを診断してみよう」のタブとカード。支給デザインの `trouble-tabs` / `trouble-card` に対応する。
 *
 * 悩みの文言・アイコンの連番・並び順・改行位置は支給デザインどおり。
 * **末尾3枚（`L62` `520` `516`）だけは支給に無い後追いの追加**で、改行位置はこちらで決めた
 * （`docs/design-renewal/CORRECTIONS.md` V-33）。
 * 遷移先は商品詳細なので商品コードだけを持ち、パスは `assembleDetailPagePath` で組む。
 * `icon` の連番はアイコン画像のファイル名と `trouble-card_icon` の修飾クラス（サイズ個別調整）を兼ねる。
 */
export const TROUBLE_TABS: ReadonlyArray<TroubleTab> = [
  {
    id: 'daily',
    label: '日々の<br class="sp-only" />お悩み',
    iconName: 'daily',
    // 支給デザインは1本目だけ高さ調整用の修飾クラスを持つ
    iconModifier: 'daily',
  },
  {
    id: 'physical',
    label: '身体の<br class="sp-only" />お悩み',
    iconName: 'physical',
    iconModifier: '',
  },
  {
    id: 'diet',
    label: '食生活の<br class="sp-only" />お悩み',
    iconName: 'diet',
    iconModifier: '',
  },
] as const;

export const TROUBLE_CARDS: ReadonlyArray<TroubleCard> = [
  // 日々のお悩み
  {
    panel: 'daily',
    icon: '001',
    text: '気力に満ちた<br class="sp-only" />毎日を<br class="pc-only" />過ごしたい',
    productCode: '501',
  },
  {
    panel: 'daily',
    icon: '002',
    text: '安定した健康を<br />手に入れたい',
    productCode: '559',
  },
  {
    panel: 'daily',
    icon: '003',
    text: '女性ならではの<br />ゆらぎに対策したい',
    productCode: '810',
  },
  {
    panel: 'daily',
    icon: '004',
    text: '水素で若々しさを<br />ケアしたい',
    productCode: 'K42',
  },
  {
    panel: 'daily',
    icon: '005',
    text: '認知機能を<br class="sp-only" />維持したい',
    productCode: '210',
  },
  {
    panel: 'daily',
    icon: '006',
    text: '毎朝すっきり<br />快調に暮らしたい',
    productCode: '592',
  },
  {
    panel: 'daily',
    icon: '017',
    text: 'エネルギッシュに<br />活動したい',
    productCode: 'L62',
  },
  // 身体のお悩み
  {
    panel: 'physical',
    icon: '016',
    text: '敏感・デリケートな<br />悩みを対策したい',
    productCode: '525',
  },
  {
    panel: 'physical',
    icon: '008',
    text: 'くっきりクリアな<br />毎日を過ごしたい',
    productCode: '510',
  },
  {
    panel: 'physical',
    icon: '009',
    text: '年齢を重ねても<br />しっかりした歩みを<br class="sp-only" />続けたい',
    productCode: '530',
  },
  {
    panel: 'physical',
    icon: '010',
    text: 'ひやっとする不安に<br />対策したい',
    productCode: '513',
  },
  {
    panel: 'physical',
    icon: '011',
    text: '若々しい肌を<br class="sp-only" />目指したい',
    productCode: 'NS1',
  },
  {
    panel: 'physical',
    icon: '007',
    text: '日々の守る力を<br />対策したい',
    productCode: '520',
  },
  // 食生活のお悩み
  {
    panel: 'diet',
    icon: '012',
    text: '食事以外で野菜や<br />たんぱく質を<br class="sp-only" />補いたい',
    productCode: '710',
  },
  {
    panel: 'diet',
    icon: '013',
    text: 'ビタミンや<br class="sp-only" />ミネラルを<br />補いたい',
    productCode: 'L61',
  },
  {
    panel: 'diet',
    icon: '014',
    text: '毎日の乾杯を<br class="sp-only" />ケアしたい',
    productCode: '512',
  },
  {
    panel: 'diet',
    icon: '015',
    text: '乾杯もダイエットも<br />サポートしたい',
    productCode: '777',
  },
  {
    panel: 'diet',
    icon: '018',
    text: '食事の栄養バランスに<br />気をつけたい',
    productCode: '516',
  },
] as const;
